import React, { useState } from "react";

import "react-quill/dist/quill.snow.css";
import { API } from "aws-amplify";
import config from "../../../config/aws-exports";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import swal from "@sweetalert/with-react";
import { Constants } from "../../../config/Constants";
import { ReactComponent as Close } from "../../../assets/icons/close_black_24dp.svg";

const RegistersUsers = ({
  open,
  onClose,
  selectedUsers,
  setSelectedUsers,
  getRegisteredUsers,

  sid,
}) => {
  const [csvFile, setCsvFile] = useState("");
  const [fileErr, setFileErr] = useState();
  const [csvArray, setCsvArray] = useState([]);
  const [userData, setUserData] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [spin, setSpin] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const handleClose = () => {
    //console.log("closed");
    onClose();
  };

  function getExtension(filename) {
    var parts = filename.split(".");
    return parts[parts.length - 1];
  }

  function isCSV(filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case "csv":
        return true;
      default:
        return false;
    }
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!isCSV(e.target.files[0].name)) {
      swal("Oops!", "Select correct file format..!", "error");
      return;
    }
    setCsvFile(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      const xd = e.target.result;
      //console.log(xd);
      var array = CSVToArray(xd);
      var objArray = [];
      for (var i = 1; i < array.length; i++) {
        objArray[i - 1] = {};
        for (var k = 0; k < array[0].length && k < array[i].length; k++) {
          var key = array[0][k];

          //console.log("key", key);

          if (array[i][k] !== undefined) {
            objArray[i - 1][key] =
              key === "Email" ? array[i][k].toLowerCase() : array[i][k];
          }
        }
      }

      // console.log("objArray", objArray);

      var filteredarray;

      filteredarray = objArray.filter(
        (key) => key.Email !== undefined && key.Email !== "",
      );

      // console.log("filteredarray", filteredarray);
      setCsvArray(filteredarray);
    };
    reader.readAsText(file);
  };

  const CSVToArray = function (strData, strDelimiter) {
    strDelimiter = strDelimiter || ",";

    var objPattern = new RegExp(
      "(\\" +
        strDelimiter +
        "|\\r?\\n|\\r|^)" +
        '(?:"([^"]*(?:""[^"]*)*)"|' +
        '([^"\\' +
        strDelimiter +
        "\\r\\n]*))",
      "gi",
    );

    var arrData = [[]];

    var arrMatches = null;

    while ((arrMatches = objPattern.exec(strData))) {
      var strMatchedDelimiter = arrMatches[1];

      if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
        arrData.push([]);
      }

      if (arrMatches[2]) {
        var strMatchedValue = arrMatches[2].replace(new RegExp('""', "g"), '"');
      } else {
        // We found a non-quoted value.
        strMatchedValue = arrMatches[3].length === 0 ? "" : arrMatches[3];
      }

      arrData[arrData.length - 1].push(strMatchedValue);
    }

    //console.log("arrData", arrData);
    return arrData;
  };

  const onsubmit = () => {
    // let formIsValid = true;

    setErrorData([]);
    setUserData([]);
    setFileErr("");
    var temp = [];
    var temp2 = [];
    let hasInvalidEmail = false;
    let hasInvalidDate = false;

    if (csvFile === undefined || csvFile === "") {
      setFileErr("Please select csv file to upload");
      return;
    }

    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w&-]+(?:\.[\w&-]+)*)|("[\w-\s]+")([\w&-]+(?:\.[\w&-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
    );

    //console.log("csvArray", csvArray);

    if (csvArray.length > 0) {
      for (var i = 0; i < csvArray.length; i++) {
        if (
          csvArray[i].Email !== undefined &&
          csvArray[i].Email !== "" &&
          csvArray[i].date !== undefined &&
          csvArray[i].date.trim() !== null &&
          (csvArray[i].Role === "User" || csvArray[i].Role === "Manager") &&
          pattern.test(csvArray[i].Email)
        ) {
          temp.push(csvArray[i]);
        } else {
          if (
            csvArray[i].Email !== undefined &&
            csvArray[i].Email !== "" &&
            !pattern.test(csvArray[i].Email)
          ) {
            hasInvalidEmail = true;
            temp2.push(csvArray[i]);
          }

          if (
            csvArray[i].date === undefined ||
            csvArray[i].date === null ||
            String(csvArray[i].date).trim() === ""
          ) {
            hasInvalidDate = true;
            temp2.push(csvArray[i]);
          }

          temp2.push(csvArray[i]);
        }
      }
    }
    setErrorData(temp2);
    if (csvArray.length === 0) {
      setFileErr("File has no records");
      return;
    }

    if (hasInvalidDate) {
      setFileErr(
        "Invalid Date. Please provide date in all records and upload again.",
      );
      setErrorData([]);
      return;
    }

    if (hasInvalidEmail) {
      setFileErr(
        "Invalid Email ID. Please remove from the file and upload again.",
      );
      return;
    }

    changeFormat(csvArray);
  };

  async function changeFormat(temp) {
    setSpin(true);
    const bodyParam = {
      body: {
        jsonfile: temp,
        oid: config.aws_org_id,
        schema: Constants.SCHEMA_NAME,
        sid: sid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/registerUsers",
        bodyParam,
        //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
      );
      // const users = response;

      if (response !== null && (response.code === 2 || response.code === 3)) {
        setUserData(response.userData);
        setErrorMessage(response.errorMessage);
      }

      if (response !== null && response.code === 1) {
        handleClose();

        swal({
          title: "Oooops!",
          text: response.Message,
          icon: "warning",
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            handleClose();
          }
        });
      }

      if (response && response.code === 4) {
        setSpin(false);

        handleClose();
        getRegisteredUsers();

        swal({
          title: "Success",
          text: response.Message,
          icon: "success",
          dangerMode: false,
        });

        return;
      }

      setSpin(false);
    } catch (error) {
      handleClose();
      swal({
        title: "Success",
        text: "All users added successfully",
        icon: "success",
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          handleClose();
        }
      });
      setSpin(false);
    }
  }

  async function downloadcsv() {
    try {
      const response = await fetch(
        `https://${config.DOMAIN}/registerUsers.csv`,
      );
      const data = await response.text();
      const blob = new Blob([data], { type: "data:text/csv;charset=utf-8," });
      const url = window.URL.createObjectURL(blob);
      let dwldLink = document.createElement("a");
      let isSafariBrowser =
        navigator.userAgent.indexOf("Safari") !== -1 &&
        navigator.userAgent.indexOf("Chrome") === -1;
      if (isSafariBrowser) {
        //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
      }
      dwldLink.setAttribute("href", url);
      dwldLink.setAttribute("download", "registerUsers.csv");
      dwldLink.style.visibility = "hidden";
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div>
      {spin && (
        <Backdrop
          open={true}
          style={{
            zIndex: 10000,
            color: "#fff",
          }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            background: "#fff",
            width: "600px",
            padding: "20px",
            borderRadius: "6px",
            height: "350px",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3>Register Users</h3>

            <Close
              style={{ cursor: "pointer" }}
              onClick={() => handleClose()}
            />
          </div>

          <div
            style={{
              color: "#cc0000",
              marginBottom: "12px",
              marginTop: "-10px",
              textAlign: "start",
              fontSize: "13px",
            }}
          >
            <p>{fileErr}</p>
          </div>

          <div
            //className={User.field}
            style={{
              border: "1px solid gray",
              padding: "50px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div style={{ marginLeft: "8rem" }}>
              <input
                type="file"
                id="files"
                accept=".csv"
                onChange={(e) => handleFileUpload(e)}
              />
            </div>

            <button
              style={{
                fontSize: "13px",
                cursor: "pointer",
                color: "blue",
                background: "none",
                border: "none",
                padding: 0,
                textDecoration: "underline",
                margin: "1rem",
              }}
              onClick={downloadcsv}
            >
              Download Format
            </button>
          </div>

          {userData.length > 0 ? (
            <>
              <p style={{ fontSize: "14px", textAlign: "left" }}>
                {errorMessage}
              </p>

              <div
                style={{
                  overflow: "scroll",
                  marginTop: "10px",
                }}
              >
                <table style={{ fontSize: "14px", width: "100%" }}>
                  <thead style={{ backgroundColor: "aliceblue" }}>
                    <th>Email</th>
                  </thead>
                  <tbody>
                    {userData.map((item, i) => (
                      <tr key={i}>
                        <td>{item.Email}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : null}

          {errorData.length > 0 ? (
            <>
              {/* <p style={{ fontSize: "14px", textAlign: "left" }}>
                Below are the invalid entries please remove from file and upload
                again.
              </p> */}

              <div
                style={{
                  overflow: "scroll",
                  marginTop: "10px",
                }}
              >
                <table style={{ fontSize: "14px", width: "100%" }}>
                  <thead style={{ backgroundColor: "aliceblue" }}>
                    <th>Email</th>
                  </thead>
                  <tbody>
                    {errorData.map((item, i) => (
                      <tr key={i}>
                        <td>{item.Email}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : null}

          <div
            style={{ margin: "2rem", textAlign: "center" }}
            onClick={onsubmit}
          >
            <button
              style={{
                background: "var(--color-button-background)",
                padding: "10px 20px",
                width: "fit-content",
                height: "fit-content",
                fontSize: "14px",
                color: "white",
                fontWeight: 300,
                borderRadius: "5px",
                border: "none",
                margin: "0px",
              }}
            >
              SAVE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistersUsers;
